module.exports = __webpack_public_path__ + "bower_components/ngWYSIWYG/dist/images/header-bg.gif";


/*****************
 ** WEBPACK FOOTER
 ** ./bower_components/ngWYSIWYG/dist/images/header-bg.gif
 ** module id = 149
 ** module chunks = 1
 **/